import { useAuthorizedQuery } from "../api/authorized-query";
import { useQuery } from "@tanstack/vue-query";
import { seedgreenAPI } from "../api/axios";
import { STALE_TIME_LONG } from "../queries/query.constants";
import { HarvestOverviewRanchDTO, UnifiedHarvestDataPointDTO, } from "../dtos/HarvestOverviewDTO";
import { useRanches } from "../queries/ranch";
import { useRanchSeasons } from "../queries/ranch-season";
const HARVEST_OVERVIEW_RANCHES_STALE_TIME = STALE_TIME_LONG;
export function useHarvestOverviewRanches() {
    // Source queries
    const ranchesQuery = useRanches();
    const ranchSeasonsQuery = useRanchSeasons();
    const query = useQuery({
        enabled: useAuthorizedQuery(),
        queryKey: [
            "harvest-overview-ranches",
            ranchesQuery.dataUpdatedAt,
            ranchSeasonsQuery.dataUpdatedAt,
        ],
        queryFn: () => {
            const ranches = ranchesQuery.ranches?.value || [];
            const ranchSeasons = ranchSeasonsQuery.ranchSeasons?.value || [];
            const seasonsByRanchId = new Map();
            for (const rs of ranchSeasons) {
                const list = seasonsByRanchId.get(rs.ranchId) || [];
                list.push(rs);
                seasonsByRanchId.set(rs.ranchId, list);
            }
            const result = (ranches || [])
                .map((r) => {
                const seasons = seasonsByRanchId.get(r.id) || [];
                const clonedSeasons = seasons.map((s) => ({
                    id: s.id,
                    ranchId: s.ranchId,
                    coolerId: s.coolerId,
                    organicStatusId: s.organicStatusId,
                    seasonId: s.seasonId,
                    ranchCode: s.ranchCode,
                }));
                return new HarvestOverviewRanchDTO({
                    id: r.id,
                    name: r.name,
                    growerId: r.growerId ?? null,
                    growerName: r.growerName ?? "",
                    customerId: r.customerId,
                    lastUpdatedUserId: r.lastUpdatedUserId ?? null,
                    seasons: clonedSeasons,
                });
            })
                .sort((a, b) => (a.growerName || "").localeCompare(b.growerName || "") || a.name.localeCompare(b.name));
            return result;
        },
        staleTime: HARVEST_OVERVIEW_RANCHES_STALE_TIME,
    });
    return {
        ranches: query.data,
        ...query,
    };
}
export function useUnifiedHarvestData(startDate, endDate, ranchIds, organics, season) {
    const query = useQuery({
        enabled: useAuthorizedQuery(),
        queryKey: [
            "unified-harvest-data",
            startDate,
            endDate,
            ranchIds,
            organics,
            season,
        ],
        queryFn: async () => {
            const response = await seedgreenAPI.get("/v2/HarvestOverview/Unified", {
                params: {
                    startDate: startDate.value,
                    endDate: endDate.value,
                    ranchIds: ranchIds.value.join(",") || undefined,
                    organicStatus: organics.value,
                    seasonId: season.value,
                },
            });
            return response.data;
        },
        staleTime: HARVEST_OVERVIEW_RANCHES_STALE_TIME,
        select: (data) => {
            try {
                return data.map((dataPoint) => new UnifiedHarvestDataPointDTO(dataPoint));
            }
            catch (error) {
                console.error("query/unified-harvest-data::select ERROR", error);
            }
        },
    });
    return {
        unifiedData: query.data,
        ...query,
    };
}
